import {useMatchMedia} from '@pexip/hooks';

import {PORTRAIT} from '../../constants/mediaQueries';

export const usePortrait = () => useMatchMedia(PORTRAIT);
